import React from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Button, Backdrop, Divider, LinearProgress, Typography, Box } from '@mui/material';
import { AuthContext } from '../../../contexts/auth';

const HOST = process.env.REACT_APP_HOST;

export default function RemoveCompanyMonth() {
  const { token, loading, toggleLoading, logout } = React.useContext(AuthContext);
  const [cnpj, setCnpj] = React.useState('');
  const [mesAno, setMesAno] = React.useState('');
  const [mesAnoAll, setMesAnoAll] = React.useState('');
  const [logs, setLogs] = React.useState([]);
  const [progress, setProgress] = React.useState(0);

  const formatCNPJ = (value) => {
    value = value.replace(/\D/g, '');
    value = value.replace(/^(\d{2})(\d)/, '$1.$2');
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
    value = value.replace(/(\d{4})(\d)/, '$1-$2');
    return value.substring(0, 18);
  };

  const formatMesAno = (value) => {
    value = value.replace(/\D/g, '');
    if (value.length > 2) {
      value = value.replace(/^(\d{2})(\d{1,4})/, '$1/$2');
    }
    return value.substring(0, 7);
  };

  const handleRemoveWithProgress = async (url, body) => {
    toggleLoading(true);
    setLogs([]);
    setProgress(0);

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      });
      const interval = setInterval(() => {
          setProgress(prev => {
            if (prev >= 80) {
              clearInterval(interval);
              return prev;
            }
            return prev + 7;
          });
        }, 1000);

      const data = await response.json();

      if (data.logs && Array.isArray(data.logs)) {
        setLogs(data.logs);
      } else {
        setLogs([JSON.stringify(data)]);
      }

      setProgress(100);
      setTimeout(() => {
        toggleLoading(false);
        setProgress(0);
      }, 100);

    } catch (err) {
      toggleLoading(false);
      setProgress(0);
      alert('Erro na comunicação com o servidr: ' + err.message);
      console.error(err);
    }
  };

  const handleRemove = () => {
    if (!cnpj || !mesAno) {
      alert('Preencha CNPJ e Mês/Ano.');
      return;
    }
    handleRemoveWithProgress(`${HOST}/api/admin/removeEmpresa`, { cnpj, mes_ano: mesAno });
  };

  const handleRemoveAll = () => {
    if (!mesAnoAll) {
      alert('Preencha o Mês/Ano.');
      return;
    }
    handleRemoveWithProgress(`${HOST}/api/admin/removerMes`, { mes_ano: mesAnoAll });
  };

  return (
    <Paper sx={{ width: '90%', padding: 2, overflow: 'hidden' }}>
      <h2>Remover Dados da Empresa por Mês</h2>

      <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
        <TextField
          label="CNPJ"
          value={cnpj}
          onChange={(e) => setCnpj(formatCNPJ(e.target.value))}
          fullWidth
        />
        <TextField
          label="Mês/Ano (MM/YYYY)"
          value={mesAno}
          onChange={(e) => setMesAno(formatMesAno(e.target.value))}
          fullWidth
        />
        <Button
          variant="contained"
          color="error"
          onClick={handleRemove}
        >
          Remover Dados
        </Button>
      </div>

      <Divider sx={{ my: 3 }} />

      <h2>Remover TODOS os Dados do Mês</h2>
      <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
        <TextField
          label="Mês/Ano (MM/YYYY)"
          value={mesAnoAll}
          onChange={(e) => setMesAnoAll(formatMesAno(e.target.value))}
          fullWidth
        />
        <Button
          variant="contained"
          color="error"
          onClick={handleRemoveAll}
        >
          Remover Tudo
        </Button>
      </div>

      {logs.length > 0 && (
        <TableContainer>
          <Table aria-label="logs table">
            <TableHead>
              <TableRow>
                <TableCell>Logs</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logs.map((log, index) => (
                <TableRow key={index}>
                  <TableCell>{log}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Backdrop
        sx={{ color: '#fff', backgroundColor: 'rgba(0,0,0,0.6)', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <Box sx={{ width: '60%', textAlign: 'center' }}>
          <LinearProgress variant="determinate" value={progress} sx={{ mb: 2 }} />
          <Typography variant="body2">{progress < 100 ? 'Processando...' : 'Concluído!'}</Typography>
          <Typography variant="body2">{`${progress}%`}</Typography>
        </Box>
      </Backdrop>
    </Paper>
  );
}
